export enum PageMessageIconType {
  Warning,
  Information,
  Error,
}
